import React from "react";

const SearchIcon = ({name, color, size}) => (
    <svg viewBox="0 0 33 32" className={`icon icon-${name}`} fill={color} width={size} height={size}  xmlns="http://www.w3.org/2000/svg">
        <path d="M23.219 4.719c-5.137-5.137-13.397-5.137-18.534 0s-5.137 13.397 0 18.534c5.137 5.137 13.397 5.137 18.534 0s5.137-13.397 0-18.534zm-2.115 16.418c-3.928 3.928-10.375 3.928-14.303 0s-3.928-10.375 0-14.303c3.928-3.928 10.375-3.928 14.303 0s3.928 10.375 0 14.303z" />
        <path d="M22.011 21.036c.705-.705 1.209-1.108 2.518.201l6.044 5.943c1.309 1.309 1.914 2.921 1.209 3.626s-2.317.101-3.626-1.209l-6.044-5.943c-1.309-1.309-.806-1.914-.101-2.619z"/>
    </svg>
);

export default SearchIcon;